// Module
var code = "<div id=\"ratingStar\"> <star-icon data-ng-repeat=\"i in vm.getArrayNumber() track by $index\" data-ng-class=\"vm.getClass($index+1)\" data-ng-click=\"vm.setRating($index+1)\" data-ng-mouseover=\"vm.onHover($index+1)\" data-ng-mouseleave=\"vm.onLeave()\"></star-icon> </div> ";
// Exports
module.exports = code;